import React from 'react';

import MessageInfo from '../../../components/messageInfo/MessageInfo';
import { useGetScorecardStatusQuery } from '../../../pages/compensation/compensationSlice';
import { ScoreCardPropTypes } from '../types';

const StatusDetail = ({ inputYear, inputMonth, inputScorecardVersion }: ScoreCardPropTypes) => {
    const { data: scorecardStatusData } = useGetScorecardStatusQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion }
    );

    if (scorecardStatusData?.data?.length > 0) {
        return (
            <div className="card shadow border-0 h-100 borderRadius10">
                <div className="card-body">
                    <h6 className="card-title">Status</h6>
                    <hr className="mt-2" />
                    <div className="row">
                        <div className="col-md-9">Associates on Scorecard</div>
                        <div className="col-md-3">
                            <span>{scorecardStatusData?.data?.[0].associates_on_scorecard}</span>
                        </div>
                    </div>

                    <div className="row mt-3 mb-5">
                        <div className="col-md-9">Associates approved by manager</div>
                        <div className="col-md-3">
                            {scorecardStatusData?.data?.[0].associates_approved_by_manager}
                        </div>
                    </div>

                    <h6 className="card-title">Disputes</h6>
                    <hr className="mt-2" />
                    <div className="row">
                        <div className="col-md-9">Open metric disputes</div>
                        <div className="col-md-3">{scorecardStatusData?.data?.[0].open_metric_disputes}</div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-9">Open scorecard disputes</div>
                        <div className="col-md-3">
                            {scorecardStatusData?.data?.[0].open_scorecard_disputes}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="col-12">
            <h6 className="card-title ms-3 mt-2">Status</h6>
            <hr className="mt-2" />
            <MessageInfo
                title="No results found."
                message="Try adjusting the month or scorecard filter above."
                rowHeight="308px"
            />
        </div>
    );
};

export default StatusDetail;
